const DETAILS = {
  home: `DESIGN. DEVELOP. DELIVER.`,
  about: `Erom Studio blends creativity with technology to craft exceptional digital experiences. We specialize in UI/UX design, web development, and app development, collaborating closely with clients to bring their vision to life. From stunning websites to intuitive mobile apps, we design, develop, and deliver impactful solutions that drive success.`,
  email: `team@eromstudio.in`,
  lineedIn: `https://www.linkedin.com/company/erom-studio`,
  instagram: `https://www.instagram.com/erom.studio`,
};
export default DETAILS;
